<script lang="ts" module>
  import type { Range } from 'libchartium';
  import { mut, type WritableSignal } from '@typek/signalhead';
  import { setContext, type ContextKey } from '#lib/utils/svelte-context.js';
  import type { Snippet } from 'svelte';

  export const CommonXRangeContextKey: ContextKey<WritableSignal<Range | undefined>> =
    Symbol('CommonXRangeContext');
</script>

<script lang="ts">
  let { children }: { children?: Snippet } = $props();

  let commonXRange = mut<Range>();
  setContext(CommonXRangeContextKey, commonXRange);
</script>

{@render children?.()}
